import Vue from 'vue'
import VueRouter from 'vue-router'
import storage from '@/mixins/storage'
import Login from '@/views/full-page/LoginView.vue'
import ResetSenha from '@/views/full-page/ResetSenha.vue'
import RecuperarSenha from '@/views/full-page/RecuperarSenha.vue'
import Perfil from '@/views/ProfileView.vue'
import HomeView from '@/views/HomeView.vue'
import ListAtivacoes from '@/views/veiculos/ListAtivacoes.vue'
import ConsultarPlaca from '@/views/veiculos/ConsultarPlaca.vue'
import ListVeiculo from '@/views/veiculos/ListVeiculo'
import FormVeiculo from '@/views/veiculos/FormVeiculo.vue'
import ListPessoa from '@/views/pessoas/ListPessoa'
import FormPessoa from '@/views/pessoas/FormPessoa'
import ListUsuario from '@/views/configuracoes/ListUsuario.vue'
import FormUsuario from '@/views/configuracoes/FormUsuario.vue'
import ListExterno from '@/views/externos/ListExterno.vue'
import FormExterno from '@/views/externos/FormExterno.vue'
import FormDocs from '@/views/pessoas/FormDocs.vue'
import ListAutorizacao from '@/views/agendamentos/ListAgendamento.vue'
import FormAutorizacao from '@/views/agendamentos/FormAgendamento.vue'
import ListPerfis from '@/views/configuracoes/ListPerfis.vue'
import FormPerfil from '@/views/configuracoes/FormPerfil.vue'
import ViewFormAcessoPessoa from '@/views/acessos/ViewFormAcessoPessoa.vue'
import ViewFormAcessoVeiculo from '@/views/acessos/ViewFormAcessoVeiculo.vue'
import ListAcessoPessoa from '@/views/acessos/ListAcessoPessoa.vue'
import ListAcessoVeiculo from '@/views/acessos/ListAcessoVeiculo.vue'
import ValidacaoQRCode from '@/views/pessoas/ValidacaoQRCode.vue'
import ListDispositivos from '@/views/dispositivos/ListDispositivos.vue'
import FormDispositivos from '@/views/dispositivos/FormDispositivos.vue'
import FormDocumentosDispositivo from '@/views/dispositivos/FormDocumentosDispositivo.vue'

Vue.use(VueRouter)

const routes = [
  { meta: { title: 'Dashboard', requiresAuth: true }, path: '/', name: 'home', component: HomeView },
  
  //Veículos Router
  // { meta: { title: 'Veículos', requiresAuth: true }, path: '/veiculos', name: 'ListVeiculo', component: ListVeiculo },
  // { meta: { title: 'Adicionar Veículo', requiresAuth: true }, path: '/adicionarVeiculo', name: 'FormVeiculo', component: FormVeiculo },
  // { meta: { title: 'Alterar Veículo', requiresAuth: true }, path: '/alterarVeiculo/:id', name: 'FormVeiculo.edit', component: FormVeiculo, props: true },
  { meta: { title: 'Ativações', requiresAuth: true }, path: '/ativacoes', name: 'Ativações', component: ListAtivacoes },
  { meta: { title: 'Consultar Placa', requiresAuth: true }, path: '/ConsultarPlaca', name: 'ConsultarPlaca', component: ConsultarPlaca },
  
  //Pessoas Router
  // { meta: { title: 'Pessoas', requiresAuth: true }, path: '/pessoas', name: 'ListPessoa', component: ListPessoa },
  // { meta: { title: 'Adicionar Pessoa', requiresAuth: true }, path: '/adicionarPessoa', name: 'FormPessoa', component: FormPessoa },
  // { meta: { title: 'Alterar Pessoa', requiresAuth: true }, path: '/alterarPessoa/:id', name: 'FormPessoa.edit', component: FormPessoa, props: true },
  { meta: { title: 'Documentos', requiresAuth: true }, path: '/documentos/:idPessoa', name: 'FormDocs', component: FormDocs },

  //Usuario Router
  { meta: { title: 'Usuários', requiresAuth: true }, path: '/usuarios', name: 'ListUsuario', component: ListUsuario },
  { meta: { title: 'Adicionar Usuário', requiresAuth: true }, path: '/adicionarUsuario', name: 'FormUsuario', component: FormUsuario },
  { meta: { title: 'Alterar Usuário', requiresAuth: true }, path: '/alterarUsuario/:id', name: 'FormUsuario.edit', component: FormUsuario, props: true },

  //Externos Router
  { meta: { title: 'Externos', requiresAuth: true }, path: '/externos', name: 'ListExterno', component: ListExterno },
  { meta: { title: 'Adicionar Externo', requiresAuth: true }, path: '/adicionarExterno', name: 'FormExterno', component: FormExterno },
  { meta: { title: 'Alterar Externo', requiresAuth: true }, path: '/alterarExterno/:id', name: 'FormExterno.edit', component: FormExterno, props: true },

  //Agendamento Router
  { meta: { title: 'Agendamento', requiresAuth: true }, path: '/agendamentos', name: 'ListAgendamentos', component: ListAutorizacao },
  { meta: { title: 'Adicionar Autorização', requiresAuth: true }, path: '/formAutorizacao', name: 'FormAgendamento', component: FormAutorizacao },
  { meta: { title: 'Autorização', requiresAuth: true }, path: '/formAutorizacao/:id', name: 'FormAgendamento.edit', component: FormAutorizacao, props: true },

  //Perfil Router
  { meta: { title: 'Profile', requiresAuth: true }, path: '/perfil', name: 'Perfil',  component: Perfil },
  { meta: { title: 'Gerenciar Perfis', requiresAuth: true }, path: '/gerenciarPerfis', name: 'ListPerfis',  component: ListPerfis },
  { meta: { title: 'Adicionar Perfil', requiresAuth: true }, path: '/formPerfil', name: 'FormPerfil',  component: FormPerfil },
  { meta: { title: 'Atualizar Perfil', requiresAuth: true }, path: '/formPerfil/:id', name: 'FormPerfil.edit',  component: FormPerfil, props: true },
  // Acessos Router
  //Pessoas
  { meta: { title: 'Listar Acessos de Pessoas', requiresAuth: true }, path: '/acessos/pessoas', name: 'AcessosPessoas', component: ListAcessoPessoa},
  { meta: { title: 'Cadastrar Acesso de Pessoa', requiresAuth: true }, path: '/acessos/cadastrar/pessoa', name: 'CriarAcessoPessoa', component: ViewFormAcessoPessoa},
  { meta: { title: 'Editar Acesso de Pessoa', requiresAuth: true }, path: '/acessos/editar/pessoa/:id', name: 'EditarAcessoPessoa', component: ViewFormAcessoPessoa, props: true},
  { meta: { title: 'Validar QR Code', requiresAuth:true }, path:'/acessos/validar-qrcode',
  name:'ValidarQRCode',
  component: () => import('@/views/pessoas/ValidacaoQRCode.vue')},
  //Veiculos
  { meta: { title: 'Listar Acessos de Veículos', requiresAuth: true }, path: '/acessos/veiculos', name: 'AcessosVeiculos', component: ListAcessoVeiculo},
  { meta: { title: 'Cadastrar Acesso de Veículo', requiresAuth: true }, path: '/acessos/cadastrar/veiculo', name: 'CriarAcessoVeiculo', component: ViewFormAcessoVeiculo},
  { meta: { title: 'Editar Acesso de Veículo', requiresAuth: true }, path: '/acessos/editar/veiculo/:id', name: 'EditarAcessoVeiculo', component: ViewFormAcessoVeiculo, props: true},

  //Dispositivos
  { meta: { title: 'Listar Dispositivos', requiresAuth: true }, path: '/dispositivos/ListDispositivos', name: 'AcessosDispositivos', component: ListDispositivos},
  { meta: { title: 'Criar Dispositivo', requiresAuth: true }, path: '/dispositivos/FormDispositivos', name: 'CriarAcessoDispositivos', component: FormDispositivos},
  { path: "/dispositivos/:id", name: "FormDispositivos.edit", component: FormDispositivos },
  { meta: { title: "Documentação do Dispositivo", requiresAuth: true, }, path: "/dispositivos/:id/documentos", name: "DocumentosDispositivo", component: FormDocumentosDispositivo, },
  { meta: { title: "Alterar Dispositivo", requiresAuth: true, }, path: "/dispositivos/:id", name: "EditarDispositivo", component: FormDispositivos, },

  //Login Router
  {
    path: '/full-page',
    component: () => import(/* webpackChunkName: "full-page" */ '@/views/FullPageView.vue'),
    children: [
      { meta: { title: 'Login', requiresAuth: false }, path: '/login', name: 'login', component: Login },
      { meta: { title: 'Recuperar Senha', requiresAuth: false }, path: '/recuperarSenha', name: 'RecuperarSenha', component: RecuperarSenha },
      { meta: { title: 'Resetar Senha', requiresAuth: false }, path: '/resetSenha', name: 'ResetSenha',  component: ResetSenha },
    ]
  },
  {
    meta: {
      title: 'Tables'
    },
    path: '/tables',
    name: 'tables',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tables" */ '@/views/TablesView.vue')
  },
  {
    meta: {
      title: 'Forms'
    },
    path: '/forms',
    name: 'forms',
    component: () => import(/* webpackChunkName: "forms" */ '@/views/FormsView.vue')
  },
  {
    meta: {
      title: 'New Client'
    },
    path: '/client/new',
    name: 'client.new',
    component: () => import(/* webpackChunkName: "client-form" */ '@/views/ClientFormView.vue')
  },
  {
    meta: {
      title: 'Edit Client'
    },
    path: '/client/:id',
    name: 'client.edit',
    component: () => import(/* webpackChunkName: "client-form" */ '@/views/ClientFormView.vue'),
    props: true
  },

]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {

  console.log("ROTA:", to.path);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!storage.methods.getToken()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router

export function useRouter() {
  return router
}
